import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Label, Aabb, Ocr, Segmentation, TextCategorization } from './types'


class TypeSwitcher extends Component {
	render() {
		const components = {
			label: Label,
			aabb: Aabb,
			ocr: Ocr,
			segmentation: Segmentation,
			textcategorization: TextCategorization,
		}
		const { toolType, ...innerProps } = this.props
		const Type = components[toolType] || Label

		return <Type {...innerProps} />
	}
}

TypeSwitcher.propTypes = {
	toolType: PropTypes.string.isRequired,
}

export default TypeSwitcher
